import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  PromptContext,
  UserContext,
  usePrompts,
  useWebsocketEffect,
} from '@eas/common-web';
import { fetchProfile } from '@modules/profile/profile-api';

export function SessionHandler() {
  const { logout } = useContext(UserContext);
  const { testPrompt } = useContext(PromptContext);

  useWebsocketEffect(() => {
    console.log('message SESSION_DESTROYED received');
    fetchProfile().response.then((r) => {
      if (!r.ok) {
        testPrompt({
          key: 'WARNING',
          submitCallback: () => {
            logout();
          },
        });
      }
    });
  }, ['SESSION_DESTROYED']);

  usePrompts(
    [
      {
        key: 'WARNING',
        dialogTitle: (
          <FormattedMessage
            id="ES__SESSION_DESTROYED__TITLE"
            defaultMessage="Varování"
          />
        ),
        dialogText: (
          <FormattedMessage
            id="ES__SESSION_DESTROYED__TEXT"
            defaultMessage="Došlo k automatickému odhlášení z důvodu neaktivity uživatele, nebo restartu systému. Pro pokračování se prosím znovu přihlaste."
          />
        ),
        dialogDisableBackdrop: true,
        dialogShowClose: false,
      },
    ],
    []
  );

  return null;
}
